import { styleFooter } from './StyleFooter'

const Footer = () => {
    const date = new Date()
    const year = date.getFullYear()

    return (
        <FooterSC>
            <FooterGridSC>
                <FooterCellSC $col={1} $row={1} $justify="start">
                    <PartWrapperSC $align="flex-start">
                        <PartTitleSC>Россия</PartTitleSC>

                        <AddressSC
                            target="_blank"
                            href="https://yandex.ru/maps/-/CCUoaJXCdB"
                        >
                            Челябинск, ул. Труда, 84, {'\n'}офис 304
                        </AddressSC>
                    </PartWrapperSC>
                </FooterCellSC>

                <FooterCellSC $col={2} $row={1} $justify="center">
                    <PartWrapperSC
                        style={{ width: 265, alignItems: 'start' }}
                        $align="center"
                    >
                        <PartTitleSC>Контакты</PartTitleSC>

                        <ContactItemSC
                            target="_blank"
                            href="mailto:info@stit.online"
                        >
                            info@stit.online
                        </ContactItemSC>

                        <ContactItemSC href="tel:+79995859605">
                            +7(993)934-99-96
                        </ContactItemSC>
                    </PartWrapperSC>
                </FooterCellSC>

                <FooterCellSC $col={3} $row={1} $justify="end">
                    <PartWrapperSC $align="flex-end">
                        <PartTitleSC>Соцсети</PartTitleSC>

                        <SocialWrapperSC>
                            <SocialItemSC
                                target="_blank"
                                href="https://vk.com/ant.aversg"
                            >
                                VK
                            </SocialItemSC>

                            <SocialItemSC
                                target="_blank"
                                href="https://t.me/tyfin"
                            >
                                TG
                            </SocialItemSC>
                        </SocialWrapperSC>
                    </PartWrapperSC>
                </FooterCellSC>

                <FooterCellSC $col={1} $row={2} $justify="start">
                    <ContactItemSC href="https://app.sheetsgpt.ru/signup?privacypolicy">
                        Политика конфиденциальности
                    </ContactItemSC>
                </FooterCellSC>

                <FooterCellSC
                    $col={2}
                    $row={2}
                    $justify="center"
                    $textAlign="center"
                >
                    <ContactItemSC
                        $maxWidth={265}
                        style={{ textAlign: 'start' }}
                        href="https://app.sheetsgpt.ru/personaldata"
                    >
                        Согласие на обработку персональных данных
                    </ContactItemSC>
                </FooterCellSC>

                <FooterCellSC
                    $col={3}
                    $row={2}
                    $justify="end"
                    $textAlign="right"
                >
                    <ContactItemSC href="https://app.sheetsgpt.ru/signup?useragreement">
                        Пользовательское соглашение
                    </ContactItemSC>
                </FooterCellSC>

                <FooterCellSC $col={1} $row={3} $justify="start">
                    <CompanySC>
                        <CompanyItemSC>ООО "СТ АЙТИ"</CompanyItemSC>
                        <CompanyItemSC>ИНН 7452164688</CompanyItemSC>
                        <CompanyItemSC>ОГРН 1237400039250</CompanyItemSC>
                    </CompanySC>
                </FooterCellSC>
                <FooterCellSC
                    $col={3}
                    $row={3}
                    $justify="end"
                    $textAlign="right"
                >
                    <CompanyItemSC></CompanyItemSC>
                </FooterCellSC>
                <FooterCellSC
                    $col={3}
                    $row={3}
                    $justify="end"
                    $textAlign="right"
                >
                    <CompanyItemSC>
                        © SheetsGPT {year}. All Rights Reserved
                    </CompanyItemSC>
                </FooterCellSC>

                <GrantSC
                    href="https://fasie.ru"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <GrantLogosSC>
                        <GrantLogoSC
                            src="/fasie-logo.svg"
                            alt="Фонд содействия инновациям"
                        />
                        <GrantDividerSC />
                        <GrantLogoSC
                            src="/univertechpred-logo.png"
                            alt="Платформа университетского технологического предпринимательства"
                        />
                    </GrantLogosSC>

                    <GrantTextSC>
                        Проект реализован при поддержке гранта Фонда содействия
                        инновациям, предоставленного в рамках программы
                        «Студенческий стартап» федерального проекта «Платформа
                        университетского технологического предпринимательства».
                    </GrantTextSC>
                </GrantSC>
            </FooterGridSC>
        </FooterSC>
    )
}

const {
    FooterSC,
    FooterGridSC,
    FooterCellSC,
    AddressSC,
    CompanySC,
    PartTitleSC,
    SocialItemSC,
    CompanyItemSC,
    ContactItemSC,
    PartWrapperSC,
    SocialWrapperSC,
    GrantSC,
    GrantLogosSC,
    GrantLogoSC,
    GrantDividerSC,
    GrantTextSC,
} = styleFooter()

export default Footer
